"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var convertChart_1 = require("./convertChart");
function transform(s, font, join) {
    if (join === void 0) { join = -1; }
    var output = [];
    for (var i = 0; i < s.length; i++) {
        output.push(convertChart_1.convertChar(s[i], font));
    }
    return output.join(join < 0 ? '' : String.fromCodePoint(join));
}
exports.transform = transform;
//# sourceMappingURL=transform.js.map